import { GlIcon, GlLabel, GlTooltipDirective } from '@gitlab/ui';
import { sortBy } from 'lodash-es';
import { isScopedLabel } from '~/lib/utils/common_utils';
import { s__, sprintf } from '~/locale';
export default {
    name: 'DropdownValueWidget',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlIcon,
        GlLabel
    },
    inject: [
        'allowScopedLabels'
    ],
    props: {
        disableLabels: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedLabels: {
            type: Array,
            required: true
        },
        allowLabelRemove: {
            type: Boolean,
            required: true
        },
        supportsLockOnMerge: {
            type: Boolean,
            required: false,
            default: false
        },
        labelsFilterBasePath: {
            type: String,
            required: true
        },
        labelsFilterParam: {
            type: String,
            required: true
        }
    },
    emits: [
        'label-removed',
        'on-collapsed-value-click'
    ],
    computed: {
        sortedSelectedLabels () {
            return sortBy(this.selectedLabels, (label)=>isScopedLabel(label) ? 0 : 1);
        },
        labelsList () {
            const labelsString = this.selectedLabels.length ? this.selectedLabels.slice(0, 5).map((label)=>label.title).join(', ') : s__('LabelSelect|Labels');
            if (this.selectedLabels.length > 5) {
                return sprintf(s__('LabelSelect|%{labelsString}, and %{remainingLabelCount} more'), {
                    labelsString,
                    remainingLabelCount: this.selectedLabels.length - 5
                });
            }
            return labelsString;
        }
    },
    methods: {
        labelFilterUrl (label) {
            return `${this.labelsFilterBasePath}?${this.labelsFilterParam}[]=${encodeURIComponent(label.title)}`;
        },
        scopedLabel (label) {
            return this.allowScopedLabels && isScopedLabel(label);
        },
        isLabelLocked (label) {
            return label.lockOnMerge && this.supportsLockOnMerge;
        },
        showCloseButton (label) {
            return this.allowLabelRemove && !this.isLabelLocked(label);
        },
        removeLabel (labelId) {
            this.$emit('label-removed', labelId);
        },
        handleCollapsedClick () {
            this.$emit('on-collapsed-value-click');
        }
    }
};
